// extracted by mini-css-extract-plugin
export default {"columnCheckbox":"DishesTableTHead_columnCheckbox__dyKZL","checkbox":"DishesTableTHead_checkbox__HYsLP","placeHolderShimmer":"DishesTableTHead_placeHolderShimmer__CAzyc"};